import '../CSS/Footer.css'
export default function Footer() {
    return (
        <footer>
            <p className="footerText">© 2024 - Jiricech2059 services | All rights reserved</p>
        </footer>
    )
}

